import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import {
  RolesPermissionsProvider,
  useRolesPermissionsContext,
} from 'pages/settings/pages/rolesPermissions/context/rolesPermissionsContextContext'
import { RolesPermissionsUi } from 'pages/settings/pages/rolesPermissions/ui/RolesPermissionsUi/RolesPermissionsUi'
import styles from './styles.module.scss'

const RolesPermissions = observer(() => {
  const [loading, isLoading] = useState(true)
  const { init } = useRolesPermissionsContext()

  useEffect(() => {
    init().then(() => isLoading(false))
  }, [])

  if (loading) return <SpinnerLoader ariaLabel={'RolesPermissionsPage'} />

  return <RolesPermissionsUi />
})

export const RolesPermissionsPage = observer(() => (
  <FullPageWrapper className={styles.page}>
    <RolesPermissionsProvider>
      <RolesPermissions />
    </RolesPermissionsProvider>
  </FullPageWrapper>
))
